import { Outlet } from 'react-router';
import { PageLayout } from '@components';

const AdminSectionLayout = () => (
  <>
    <PageLayout />
    <Outlet />
  </>
);

AdminSectionLayout.displayName = 'AdminSectionLayout';

export { AdminSectionLayout };
